import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrendsHotFlame = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "trends-hot-flame" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.846,14.222a4.338,4.338,0,0,1-4.154,4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,23.222c-4.615,0-9-3.358-9-7.5A7.658,7.658,0,0,1,7.94,8.435a.375.375,0,0,1,.515.382A4.814,4.814,0,0,0,10.1,13.1a.749.749,0,0,0,.992-.021c1.32-1.217,4.557-5.237-1.223-11.676a.375.375,0,0,1,.324-.623C15.621,1.447,21,7.571,21,13.472,21,18.472,18,23.222,12,23.222Z"
		})
	]
});
export default SvgTrendsHotFlame;
